import { useEffect, useState } from "react";
import { SESSION_TIMEOUT_MS, SESSION_CHECK_INTERVAL_MS } from "../config/constants";

/**
 * Custom hook for session management with inactivity timeout
 * @param {Object|null} user - Current user object
 * @param {Function} onSessionExpire - Callback when session expires
 * @returns {Object} Session state and handlers
 */
export function useSession(user, onSessionExpire) {
  const [lastActivity, setLastActivity] = useState(Date.now());

  // Check for session timeout
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT_MS) {
        if (onSessionExpire) {
          onSessionExpire();
        }
      }
    }, SESSION_CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [user, lastActivity, onSessionExpire]);

  // Track user activity
  useEffect(() => {
    const resetActivity = () => setLastActivity(Date.now());

    window.addEventListener("mousemove", resetActivity);
    window.addEventListener("keydown", resetActivity);

    return () => {
      window.removeEventListener("mousemove", resetActivity);
      window.removeEventListener("keydown", resetActivity);
    };
  }, []);

  return {
    lastActivity,
    resetActivity: () => setLastActivity(Date.now()),
  };
}
